import { Component, Input, OnInit } from '@angular/core';
import { Contact } from 'app/models/dto/contact.model';
import { Select, Store } from '@ngxs/store';
import { CreateContact, DeleteContact, UpdateContact } from 'ng2-app/store/contact/contact.actions';
import { ContactState } from 'app/store/contact/contact.state';
import { Observable } from 'rxjs';
import { LocaleSettingService } from 'app/services/i18n/locale-setting.service';


@Component({
  selector: 'app-edit-contact-smart',
  templateUrl: './edit-contact-smart.component.html',
  styleUrls: ['./edit-contact-smart.component.scss']
})
export class EditContactSmartComponent implements OnInit {

  @Select(ContactState.saving) saving$: Observable<{ saving: boolean, contactId: number | string }>;

  @Input() contact: Contact;
  @Input() borrowerId: number;

  constructor (
    private store: Store,
    private localeSettingService: LocaleSettingService,
  ) { }

  ngOnInit(): void {
    this.contact.country = this.localeSettingService.getLocaleFromPostalCode(this.contact.zipId);
  }


  deleteContact() {
    this.store.dispatch(new DeleteContact(this.contact.id));
  }

  saveContact(contact: Contact) {
    if (contact.id) {
      this.store.dispatch(new UpdateContact(contact));
    } else {
      contact.borrowerId = this.borrowerId;
      this.store.dispatch(new CreateContact(contact));
    }
  }

}
